import Image from './Image';

export type { ImageProps, ImageCssVars } from './Image';

export default Image;
